import cn from 'classnames'
import classNames from 'classnames'
import { Highlight } from 'legacy/lut/components/widgets/public/Highlight'
import { FC } from 'react'

import { FinancialBeautifiedValue } from 'partner360/components/financialBeautifiedValue/FinancialBeautifiedValue'

import { getValueTypeValue } from '../../helpers/getValueTypeValue'

import { IGlobalPartnerTableCellProps } from './models/globalPartnerTableCellProps'

import styles from './GlobalPartnerTableCell.module.scss'

export const GlobalPartnerTableCell: FC<IGlobalPartnerTableCellProps> = ({
  column,
  item,
  searchValue,
  valueType,
}) => {
  const measureValue = (prefix: 'GlobalPartnerTargets' | 'PartnersTargets') =>
    getValueTypeValue({
      valueType,
      defaultValue: item[`${prefix}Ndp`],
      ndpValue: item[`${prefix}Ndp`],
      netValue: item[`${prefix}Net`],
      tnetValue: item[`${prefix}TNet`],
      utnetValue: item[`${prefix}UTNet`],
    })
  const targetsGapNdpPercentage = item.TargertsGapNdpPercentage
    ? item.TargertsGapNdpPercentage.toFixed(0)
    : null
  const targetsGapNdpColor =
    item.TargertsGapNdp && item.TargertsGapNdp <= 0 ? styles.negativeNumber : styles.positiveNumber
  const targetsGapNdpPercentColor =
    item.TargertsGapNdpPercentage && item.TargertsGapNdpPercentage <= 0
      ? styles.negativeNumber
      : styles.positiveNumber

  const fullyAcknowledgedToTotalPartners = (
    (item.PartnersFullyAcknowledgedCount / item.PartnersCount) *
    100
  ).toFixed(0)
  const fullyCompletedToTotalPartners = (
    (item.PartnersCompletedCount / item.PartnersCount) *
    100
  ).toFixed(0)

  if (!column.field) {
    return null
  }

  switch (column.field) {
    case 'GlobalPartnerCompleteness':
      return (
        <td>
          <span>
            {item.GlobalPartnerFullyAcknowledged === 1 ? (
              <i id="cmp-check" className={cn(styles.icon, 'kbase kbase-check')} />
            ) : (
              `${item.GlobalPartnerCompleteness}%`
            )}
          </span>
        </td>
      )

    case 'PartnersCount':
      return (
        <td>
          <span className={styles.financialValue}>{item.PartnersCount}</span>
        </td>
      )

    case 'TotalPartnersCompleteness':
      return (
        <td>
          <span>
            {item.PartnersFullyAcknowledged === 1 ? (
              <i id="cmp-check" className={cn(styles.icon, 'kbase kbase-check')} />
            ) : (
              item.TotalPartnersCompleteness
            )}
          </span>
        </td>
      )

    case 'PartnersTargetsNdp':
    case 'GlobalPartnerTargetsNdp':
      return (
        <td>
          <FinancialBeautifiedValue
            className={styles.financialValue}
            value={measureValue(
              column.field === 'PartnersTargetsNdp' ? 'PartnersTargets' : 'GlobalPartnerTargets'
            )}
            minimumFractionDigits={0}
            maximumFractionDigits={0}
          />
        </td>
      )

    case 'TargetsGapPercentage':
      return (
        <td>
          <span className={targetsGapNdpPercentColor}>
            {targetsGapNdpPercentage ? `${targetsGapNdpPercentage}%` : '-'}
          </span>
        </td>
      )

    case 'TargetsGap':
      return (
        <td>
          <FinancialBeautifiedValue
            className={classNames(targetsGapNdpColor, styles.numbers, styles.financialValue)}
            value={item.TargertsGapNdp}
            minimumFractionDigits={0}
            maximumFractionDigits={0}
          />
        </td>
      )

    case 'PartnersCompletedCount':
      if (item.PartnersCount === 0) {
        return (
          <td>
            <span>{item.PartnersCompletedCount.toFixed(0)}</span>
          </td>
        )
      }
      return (
        <td>
          <span>
            {item.PartnersCompletedCount.toFixed(0)} / {fullyCompletedToTotalPartners}%
          </span>
        </td>
      )

    case 'PartnersFullyAcknowledgedCount':
      if (item.PartnersCount === 0) {
        return (
          <td>
            <span>{item.PartnersCompletedCount.toFixed(0)}</span>
          </td>
        )
      }
      return (
        <td>
          <span>
            {item.PartnersFullyAcknowledgedCount.toFixed(0)} / {fullyAcknowledgedToTotalPartners}%
          </span>
        </td>
      )
    default:
      if (item.Matched) {
        return (
          <td>
            <Highlight words={[searchValue]}>{item[column.field]}</Highlight>
          </td>
        )
      } else {
        return (
          <td>
            <div>{item[column.field]}</div>
          </td>
        )
      }
  }
}
